import { Box, MenuItem as MenuItemBase, styled } from '@mui/material';

export const Wrapper = styled(MenuItemBase)`
  padding: ${(p) => p.theme.spacing(1)};
  border-radius: 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0 !important;
  color: ${(p) => p.theme.palette.grey[600]};

  &:hover {
    background-color: ${(p) => p.theme.palette.primary[50]};
  }

  &.active {
    background-color: ${(p) => p.theme.palette.primary[50]};
    color: ${(p) => p.theme.palette.primary[500]};
    font-weight: ${(p) => p.theme.typography.fontWeightBold};
  }

  &.Mui-disabled {
    opacity: 1 !important;
    color: ${(p) => p.theme.palette.grey[400]};
  }
`;

export const FlexBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing(1)};
`;
